import { getMediaOwner } from './media-owners';

export interface Deal {
  id: string;
  title: string;
  description: string;
  originalPrice: number;
  discountedPrice: number;
  discountPercentage: number;
  validFrom: string;
  validTo: string;
  mediaOwnerId: string;
  mediaOwnerName: string;
  mediaOwnerLogo: string;
  inventoryType: 'Digital' | 'Classic' | 'Transit';
  location: string;
  state: string;
  city: string;
  imageUrl: string;
  impressions: number;
  uniqueVisitors: number;
  frequency: number;
  size: string;
  duration: string;
  isAvailable: boolean;
  minDuration: string;
  tags: string[];
  termsAndConditions: string[];
}

// Combined deals from all media owners
export const allDeals: Deal[] = [
  // OOH Media deals
  {
    id: 'deal-001',
    title: 'Sydney CBD Digital Bundle',
    description: 'Premium digital billboard package in Sydney\'s business district. Perfect for corporate campaigns.',
    originalPrice: 15000,
    discountedPrice: 12000,
    discountPercentage: 20,
    validFrom: '2025-02-01',
    validTo: '2025-03-31',
    mediaOwnerId: '1',
    mediaOwnerName: 'OOH Unmissable',
    mediaOwnerLogo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=100&h=100&fit=crop&crop=center',
    inventoryType: 'Digital',
    location: 'Sydney CBD, NSW',
    state: 'NSW',
    city: 'Sydney',
    imageUrl: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800&h=600&fit=crop',
    impressions: 850000,
    uniqueVisitors: 300000,
    frequency: 2.5,
    size: '1920x1080',
    duration: '10 seconds',
    isAvailable: true,
    minDuration: '2 weeks',
    tags: ['Premium Location', 'Business District', 'High Traffic'],
    termsAndConditions: [
      'Minimum booking period: 2 weeks',
      'Content approval required within 48 hours',
      'Limited time offer valid until March 31, 2025'
    ]
  },
  {
    id: 'deal-002',
    title: 'Melbourne Tram Network Special',
    description: 'Exclusive transit advertising on Melbourne\'s iconic tram network. High visibility campaign.',
    originalPrice: 8500,
    discountedPrice: 6800,
    discountPercentage: 20,
    validFrom: '2025-02-01',
    validTo: '2025-04-30',
    mediaOwnerId: '1',
    mediaOwnerName: 'OOH Unmissable',
    mediaOwnerLogo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=100&h=100&fit=crop&crop=center',
    inventoryType: 'Transit',
    location: 'Melbourne CBD, VIC',
    state: 'VIC',
    city: 'Melbourne',
    imageUrl: 'https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?w=800&h=600&fit=crop',
    impressions: 650000,
    uniqueVisitors: 300000,
    frequency: 2.5,
    size: '2400x1200',
    duration: 'Monthly',
    isAvailable: true,
    minDuration: '1 month',
    tags: ['Transit', 'Mobile Audience', 'Melbourne Exclusive'],
    termsAndConditions: [
      'Monthly booking only',
      'Includes 50 tram units',
      'Weather-resistant creative required'
    ]
  },
  {
    id: 'deal-003',
    title: 'Brisbane Highway Classic',
    description: 'Traditional billboard on Brisbane\'s major highway. Consistent visibility for brand awareness.',
    originalPrice: 5500,
    discountedPrice: 4400,
    discountPercentage: 20,
    validFrom: '2025-02-15',
    validTo: '2025-05-15',
    mediaOwnerId: '1',
    mediaOwnerName: 'OOH Unmissable',
    mediaOwnerLogo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=100&h=100&fit=crop&crop=center',
    inventoryType: 'Classic',
    location: 'Brisbane Highway, QLD',
    state: 'QLD',
    city: 'Brisbane',
    imageUrl: 'https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=800&h=600&fit=crop',
    impressions: 420000,
    uniqueVisitors: 300000,
    frequency: 2.5,
    size: '12x3m',
    duration: 'Monthly',
    isAvailable: true,
    minDuration: '1 month',
    tags: ['Highway', 'Long-term Visibility', 'Cost Effective'],
    termsAndConditions: [
      'Print production included',
      'Installation and removal included',
      'Weather damage protection'
    ]
  },

  // JCDecaux deals
  {
    id: 'deal-004',
    title: 'Airport Digital Network',
    description: 'Premium airport digital displays across major terminals. Perfect for travel and lifestyle brands.',
    originalPrice: 12000,
    discountedPrice: 9600,
    discountPercentage: 20,
    validFrom: '2025-02-01',
    validTo: '2025-03-31',
    mediaOwnerId: '2',
    mediaOwnerName: 'JCDecaux Australia',
    mediaOwnerLogo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=center',
    inventoryType: 'Digital',
    location: 'Sydney Airport, NSW',
    state: 'NSW',
    city: 'Sydney',
    imageUrl: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=800&h=600&fit=crop',
    impressions: 750000,
    uniqueVisitors: 300000,
    frequency: 2.5,
    size: '1080x1920',
    duration: '15 seconds',
    isAvailable: true,
    minDuration: '1 week',
    tags: ['Airport', 'International Audience', 'Premium'],
    termsAndConditions: [
      'Airport approval required',
      'Content restrictions apply',
      'High-impact format available'
    ]
  },
  {
    id: 'deal-005',
    title: 'Shopping Centre Bundle',
    description: 'Multiple digital screens in premium shopping centres. Ideal for retail and consumer brands.',
    originalPrice: 9500,
    discountedPrice: 7600,
    discountPercentage: 20,
    validFrom: '2025-02-10',
    validTo: '2025-04-10',
    mediaOwnerId: '2',
    mediaOwnerName: 'JCDecaux Australia',
    mediaOwnerLogo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=center',
    inventoryType: 'Digital',
    location: 'Westfield Centres, Multiple',
    state: 'NSW',
    city: 'Sydney',
    imageUrl: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800&h=600&fit=crop',
    impressions: 580000,
    uniqueVisitors: 308000,
    frequency: 2.5,
    size: '1920x1080',
    duration: '12 seconds',
    isAvailable: true,
    minDuration: '2 weeks',
    tags: ['Retail', 'Shopping', 'Consumer Focus'],
    termsAndConditions: [
      'Includes 5 shopping centre locations',
      'Weekend premium rates apply',
      'Retail content preferred'
    ]
  },

  // oOh!media deals
  {
    id: 'deal-006',
    title: 'Street Furniture Classic Package',
    description: 'Traditional street furniture advertising in high-foot-traffic areas. Great for local businesses.',
    originalPrice: 4200,
    discountedPrice: 3360,
    discountPercentage: 20,
    validFrom: '2025-02-01',
    validTo: '2025-04-30',
    mediaOwnerId: '3',
    mediaOwnerName: 'oOh!media',
    mediaOwnerLogo: 'https://images.unsplash.com/photo-1664575602276-acd073f104c1?w=100&h=100&fit=crop&crop=center',
    inventoryType: 'Classic',
    location: 'Melbourne Streets, VIC',
    state: 'VIC',
    city: 'Melbourne',
    imageUrl: 'https://images.unsplash.com/photo-1571171637578-41bc2dd41cd2?w=800&h=600&fit=crop',
    impressions: 320000,
    uniqueVisitors: 300700,
    frequency: 2.9,
    size: '1200x1800',
    duration: 'Monthly',
    isAvailable: true,
    minDuration: '1 month',
    tags: ['Street Furniture', 'Pedestrian Traffic', 'Local'],
    termsAndConditions: [
      'Includes 10 street furniture units',
      'Production and installation included',
      'Council approval handled'
    ]
  },
  {
    id: 'deal-007',
    title: 'University Campus Digital',
    description: 'Digital screens across multiple university campuses. Perfect for targeting young demographics.',
    originalPrice: 6800,
    discountedPrice: 5440,
    discountPercentage: 20,
    validFrom: '2025-02-15',
    validTo: '2025-05-15',
    mediaOwnerId: '3',
    mediaOwnerName: 'oOh!media',
    mediaOwnerLogo: 'https://images.unsplash.com/photo-1664575602276-acd073f104c1?w=100&h=100&fit=crop&crop=center',
    inventoryType: 'Digital',
    location: 'University Campuses, Multiple',
    state: 'NSW',
    city: 'Sydney',
    imageUrl: 'https://images.unsplash.com/photo-1562774053-701939374585?w=800&h=600&fit=crop',
    impressions: 450000,
    uniqueVisitors: 400000,
    frequency: 6.5,
    size: '1080x1920',
    duration: '8 seconds',
    isAvailable: true,
    minDuration: '2 weeks',
    tags: ['University', 'Young Adults', 'Education'],
    termsAndConditions: [
      'Student-friendly content required',
      'Semester booking recommended',
      'Multiple campus coverage'
    ]
  },

  // QMS Media deals
  {
    id: 'deal-008',
    title: 'Regional Highway Network',
    description: 'Digital billboards on major regional highways. Cost-effective way to reach regional audiences.',
    originalPrice: 7500,
    discountedPrice: 6000,
    discountPercentage: 20,
    validFrom: '2025-02-01',
    validTo: '2025-03-31',
    mediaOwnerId: '4',
    mediaOwnerName: 'QMS Media',
    mediaOwnerLogo: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=100&h=100&fit=crop&crop=center',
    inventoryType: 'Digital',
    location: 'Regional Highways, QLD',
    state: 'QLD',
    city: 'Regional',
    imageUrl: 'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=800&h=600&fit=crop',
    impressions: 380000,
    uniqueVisitors: 200000,
    frequency: 1.5,
    size: '1920x1080',
    duration: '10 seconds',
    isAvailable: true,
    minDuration: '1 week',
    tags: ['Regional', 'Highway', 'Cost Effective'],
    termsAndConditions: [
      'Regional coverage across Queensland',
      'Flexible booking periods',
      'Lower cost per impression'
    ]
  },
  {
    id: 'deal-009',
    title: 'Transit Hub Premium',
    description: 'High-impact displays at major transit hubs. Perfect for commuter-focused campaigns.',
    originalPrice: 11000,
    discountedPrice: 8800,
    discountPercentage: 20,
    validFrom: '2025-02-10',
    validTo: '2025-04-10',
    mediaOwnerId: '4',
    mediaOwnerName: 'QMS Media',
    mediaOwnerLogo: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=100&h=100&fit=crop&crop=center',
    inventoryType: 'Digital',
    location: 'Central Station, NSW',
    state: 'NSW',
    city: 'Sydney',
    imageUrl: 'https://images.unsplash.com/photo-1544620347-c4fd4a3d5957?w=800&h=600&fit=crop',
    impressions: 920000,
    uniqueVisitors: 350000,
    frequency: 4.5,
    size: '2560x1440',
    duration: '12 seconds',
    isAvailable: true,
    minDuration: '1 week',
    tags: ['Transit Hub', 'Commuters', 'High Impact'],
    termsAndConditions: [
      'Prime commuter hours included',
      'Weather protection guaranteed',
      'Real-time campaign monitoring'
    ]
  },

  // AdSpace Media deals
  {
    id: 'deal-010',
    title: 'Business District Classic',
    description: 'Traditional billboards in business districts. Perfect for B2B and professional services.',
    originalPrice: 8000,
    discountedPrice: 6400,
    discountPercentage: 20,
    validFrom: '2025-02-15',
    validTo: '2025-05-15',
    mediaOwnerId: '5',
    mediaOwnerName: 'AdSpace Media',
    mediaOwnerLogo: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=100&h=100&fit=crop&crop=center',
    inventoryType: 'Classic',
    location: 'Perth CBD, WA',
    state: 'WA',
    city: 'Perth',
    imageUrl: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&h=600&fit=crop',
    impressions: 520000,
    uniqueVisitors: 300000,
    frequency: 2.5,
    size: '12x3m',
    duration: 'Monthly',
    isAvailable: true,
    minDuration: '1 month',
    tags: ['Business District', 'B2B', 'Professional'],
    termsAndConditions: [
      'Business content preferred',
      'Professional design services available',
      'Long-term discounts available'
    ]
  }
];

export const getDealsByMediaOwner = (mediaOwnerId: string): Deal[] => {
  return allDeals.filter(deal => deal.mediaOwnerId === mediaOwnerId);
};

export const getAvailableDeals = (): Deal[] => {
  return allDeals.filter(deal => deal.isAvailable);
};

export const getDealsByInventoryType = (inventoryType: string): Deal[] => {
  return allDeals.filter(deal => deal.inventoryType === inventoryType);
};

export const getDealsByLocation = (state: string): Deal[] => {
  return allDeals.filter(deal => deal.state === state);
};